import React from "react";
import "./PinnedPaymentCard.css";
import { IoLocationSharp } from "react-icons/io5";


const PinnedPaymentCard = ({ pinned, formatDate, type }) => {
  if (!pinned) return null;

  const capitalizeFirstLetter = (text = "") => {
    if (!text) return "";
    return text.charAt(0).toUpperCase() + text.slice(1);
  };

  const getBookingTitle = (booking) => {
    if (!booking) return "Service";
    const serviceNameLower = booking.service_id?.serviceName?.toLowerCase() || "";
    const categoryLower = booking.serviceCategory?.toLowerCase() || "";

    if (serviceNameLower.includes("hourly") || categoryLower === "hourly") {
      const mainType = booking.eventType ? capitalizeFirstLetter(booking.eventType) : "Hourly";
      const planType = capitalizeFirstLetter(booking.subCategoryType || (serviceNameLower.includes("premium") ? "premium" : "standard"));
      return `${mainType} - ${planType}`;
    }
    if (serviceNameLower.includes("editing") || categoryLower === "editing") {
      return "Editing";
    }
    return booking.eventType ? capitalizeFirstLetter(booking.eventType) : (booking.service_id?.serviceName || booking.serviceCategory || "Service");
  };

  return (
    <div className="wa-pinned-wrapper">
      <div className="wa-pinned-content">
        {/* <span className="pin-icon">📌</span> */}

        <div className="wa-pinned-text">

          {/* 🔵 BOOKING PINNED */}
          {type === "booking" && (
            <>
              <div className="wa-title">
                {getBookingTitle(pinned)}
                {(pinned?.totalAmount || pinned?.budget) ? ` | ${String(pinned?.totalAmount || pinned?.budget || "").trim().startsWith("₹") ? "" : "₹"}${pinned?.totalAmount || pinned?.budget}` : ""}
              </div>

              <div className="wa-subtitle">
                <div>
                <span className="pin-icon"><IoLocationSharp/></span>
                {pinned?.city || pinned?.location}{pinned?.state ? `, ${pinned.state}` : ""}
              </div>
              </div>

              <div className="wa-subtitle">
                {pinned?.startDate && formatDate(pinned.startDate)} 
                {pinned?.endDate && ` – ${formatDate(pinned.endDate)}`}
              </div>

              <div className="wa-subtitle">
                Status: {pinned?.paymentStatus || pinned?.quoteStatus} 
                {pinned?.paymentMode && pinned?.paymentMode !== "NA" && ` | Mode: ${pinned.paymentMode}`}
              </div>
            </>
          )}

          {/* 🟢 QUOTE PINNED */}
          {type === "quote" && (
            <>
              <div className="wa-title">
                {pinned.eventType || pinned?.service_id?.serviceName}
                {(pinned.budget || pinned.totalAmount) ? ` • ${String(pinned.budget || pinned.totalAmount || "").trim().startsWith("₹") ? "" : "₹"}${pinned.budget || pinned.totalAmount}` : ""}
              </div>
              <div className="wa-subtitle">
                {[
                  (pinned.location || pinned.city) ? `Location: ${pinned.location || pinned.city}` : null,
                  (pinned.startDate || pinned.endDate) ? 
                    [pinned.startDate ? formatDate(pinned.startDate) : null, pinned.endDate ? formatDate(pinned.endDate) : null].filter(Boolean).join(" – ") 
                    : null
                ].filter(Boolean).join(" | ")}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default PinnedPaymentCard;


// import React from "react";
// import "./PinnedPaymentCard.css";

// const PinnedPaymentCard = ({ pinned, formatDate }) => {
//   if (!pinned) return null;

//   return (
//     <div className="wa-pinned-wrapper">
//       <div className="wa-pinned-content">
//         <span className="pin-icon">📌</span>

//         <div className="wa-pinned-text">
//           <div className="wa-title">
//             {pinned.eventType} • ₹{pinned.budget}
//           </div>
//           <div className="wa-subtitle">
//             {pinned.location} · {formatDate(pinned.startDate)} – {formatDate(pinned.endDate)}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default PinnedPaymentCard;
